<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'News', route: '/backoffice/news/' }, { label: 'Aggiungi news', route: '/backoffice/news/add' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formNews" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati</h2>
        </div>

        <div class="fld">
            <label>* Data</label>
            <p-calendar formControlName="data" dateFormat="dd/mm/yy" [showIcon]="true" styleClass="w-full" appendTo="body" />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formNews.get('data')?.hasError('required') && (formNews.get('data')?.dirty || formNews.get('data')?.touched)">La data è obbligatoria.</small>
        </div>

        <div class="fld">
            <label>* Titolo</label>
            <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formNews.get('titolo')?.hasError('required') && (formNews.get('titolo')?.dirty || formNews.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
        </div>

        <div class="fld">
            <label>Descrizione</label>
            <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
        </div>

        <div class="ac-section-head mt-2">
            <h2>Opzioni</h2>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <p-checkbox label="Evidenzia" formControlName="evidenzia" value="evidenzia" pTooltip="Se selezionato, la news verrà mostrate tra le prime posizioni" tooltipPosition="top" />
            <p-checkbox label="Link" formControlName="link" value="link" (ngModelChange)="onLink($event)" pTooltip="Se selezionato, il pulsante 'Scopri di più' della news porterà al link inserito nel campo 'Url Link'" tooltipPosition="top" />
        </div>

        <div class="fld" *ngIf="formNews.get('link')?.value && formNews.get('link')?.value.length > 0">
            <label>* Url link</label>
            <input type="text" pInputText class="w-full" placeholder="Link" formControlName="link_url" name="link_url" id="link_url" />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formNews.get('link_url')?.hasError('required') && (formNews.get('link_url')?.dirty || formNews.get('link_url')?.touched)">Inserire un URL valido.</small>
        </div>

        <div class="acc-actions">
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/news">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formNews.valid">Aggiungi</button>
        </div>
    </form>
</section>
